import { render, staticRenderFns } from "./Incestgames.vue?vue&type=template&id=0827bcd4&scoped=true&"
import script from "./Incestgames.vue?vue&type=script&lang=js&"
export * from "./Incestgames.vue?vue&type=script&lang=js&"
import style0 from "./Incestgames.vue?vue&type=style&index=0&id=0827bcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827bcd4",
  null
  
)

export default component.exports